import { saveAs } from 'file-saver'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

//UI
import { Button } from '@chakra-ui/react'

//Hooks
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import useFile from '@/features/files/useFile'

const DownloadButton = ({ fileId, fileName, displayText = 'Download' }) => {
  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()
  const dispatch = useDispatch()

  const handleDownloadFile = useCallback(async () => {
    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(fileId)

      const contentDisposition = response.headers['content-disposition']
      let finalFileName = fileName ?? 'e-approval-file'

      if (contentDisposition && contentDisposition.includes('filename=')) {
        finalFileName = contentDisposition.split('filename=')[1].replace(/"/g, '')
      }

      const blob = new Blob([response.data], {
        type: response.headers['content-type'],
      })
      saveAs(blob, finalFileName)
    } catch (err) {
      console.error('Error downloading file:', err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }, [dispatch, downloadFile, fileId])

  if (!fileId || fileId === '') {
    return <></>
  }
  return (
    <Button
      colorScheme="green"
      onClick={(e) => {
        e.stopPropagation()

        handleDownloadFile()
      }}
    >
      {displayText}
    </Button>
  )
}

export default DownloadButton
